import React from 'react';
import { useGetEnergyAccountQuery } from '../../../../service/vending-service';
import { ConsumerType } from '../../../../model/energy-profile';
import { PrepaidEnergyProfileBox } from './prepaid/PrepaidEnergyProfileBox';
import { PostpaidEnergyProfileBox } from './postpaid/PostpaidEnergyProfileBox';
import { EnergyProfileBanner } from '../energy-profile-banner/EnergyProfileBanner';
import styles from './MeterConsumptionSection.module.scss';

export const MeterConsumptionSection = React.memo(() => {
  const { data: energyProfile, isLoading, isError } = useGetEnergyAccountQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  if (isLoading) {
    return <div className={styles.skeleton} />;
  }

  const hasValidProfile =
    !isError &&
    !!(energyProfile?.meterNumber || energyProfile?.accountNumber) &&
    energyProfile?.pendingStatus !== 1 &&
    energyProfile?.pendingStatus !== 3;

  if (hasValidProfile && energyProfile.consumerType === ConsumerType.Prepaid) {
    return <PrepaidEnergyProfileBox />;
  }

  if (hasValidProfile && energyProfile.consumerType === ConsumerType.Postpaid) {
    return <PostpaidEnergyProfileBox />;
  }

  return <EnergyProfileBanner />;
});
